import { API, ENDPOINTS } from '@/app/services/api-url';
import { Stripe } from '@/app/utils/account/stripe';
import AccountApps from '@/app/modules/account/components/account-apps/account-apps.vue';
import AccountPurchases from '@/app/modules/account/components/account-purchases/account-purchases.vue';
import AccountBilling from '@/app/modules/account/components/account-billing/account-billing.vue';
import AccountPayment from '@/app/modules/account/components/account-payment/account-payment.vue';
import BillingHistory from '@/app/modules/account/components/billing-history/billing-history.vue';


export default {
  name: 'account-billing-container',
  components: {
    AccountApps,
    AccountPurchases,
    AccountBilling,
    AccountPayment,
    BillingHistory,
  },
  data: () => ({
    networkError: false,
    loading: true,
    stripe: null,
    loadingPaymentMethod: true,
    paymentMethod: null,
  }),
  computed: {
    account() {
      return this.$store.getters['account/getActiveAccount'];
    },
    subscriptions() {
      return this.$store.getters['billing/getSubscriptions'];
    },
  },
  methods: {
    async loadPaymentMethod() {
      const { uuid } = this.account;
      if (uuid) {
        return API.get(`${ENDPOINTS.GET_STRIPE_PAYMENT_METHOD}/?accountID=${uuid}`)
          .then((response) => {
            if (response.status === 200) {
              this.paymentMethod = response.data.data;
              this.loadingPaymentMethod = false;
            }
          })
          .catch((err) => {
            console.log(err);
            this.loadingPaymentMethod = false;
          });
      }
      this.loadingPaymentMethod = false;
      return false;
    },
  },
  watch: {
    account() {
      this.loadPaymentMethod();
    },
  },
  async mounted() {
    this.stripe = await Stripe(this.$store);
    await this.loadPaymentMethod();
  },
};
